import { Col, Row, Form } from "@themesberg/react-bootstrap";

const ContactInfoInput = ({ localPropertyData, setlocalPropertyData }) => {
	const handleInputChange = (e) => {
		if (!e.target.name) return;

		if (e.target.name === "phone") {
			setlocalPropertyData({
				...localPropertyData,
				[e.target.name]: e.target.value.split(",").map((i) => i.trim()),
			});
		} else {
			setlocalPropertyData({ ...localPropertyData, [e.target.name]: e.target.value });
		}
	};

	return (
		<div className="px-5">
			<center>
				<h5 className="mb-4">Contact information</h5>
			</center>

			<Row>
				<Col md={6} className="mb-3">
					<Form.Group id="propertyEmail">
						<Form.Label>Email</Form.Label>
						<Form.Control
							required
							type="text"
							name="email"
							value={localPropertyData?.["email"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Enter email address"
						/>
					</Form.Group>
				</Col>
				<Col md={6} className="mb-3">
					<Form.Group id="propertyWebsite">
						<Form.Label>Website</Form.Label>
						<Form.Control
							required
							type="text"
							name="website"
							value={localPropertyData?.["website"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Enter website"
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="mb-3">
					<Form.Group id="propertyEmail">
						<Form.Label>Phone numbers</Form.Label>
						<Form.Control
							required
							type="text"
							name="phone"
							value={localPropertyData?.["phone"].join(", ") ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Enter phone number (if multiple, use comma to separate)"
						/>
					</Form.Group>
				</Col>
			</Row>
		</div>
	);
};

export default ContactInfoInput;
